module.exports = __webpack_public_path__ + "img/pumping-activities-title.863d7b6c.png";